<template>
  <div class="wrapper">
    <parallax class="page-header header-filter"></parallax>
    <div class="">
      <div class="section text-center t_step t_content">
        <md-card class="container">
          <div class="md-layout text-left">
            <div class="md-layout-item md-size-100 md-small-size-100">
              <md-toolbar class="md-primary">
                <div class="md-toolbar-row">
                  <div class="md-toolbar-section-start">
                    <h3 class="md-title text-bold">ALL LINKS</h3>
                    <md-list>
                      <md-list-item href="manageMeetingRoom">
                        <p>Change Meeting Room</p>
                      </md-list-item>

                      <md-list-item href="manageGuestRoom">
                        <p>Change Guest Room</p>
                      </md-list-item>

                      <md-list-item href="meetingHistory">
                        <p>Meeting Reservation</p>
                      </md-list-item>

                      <md-list-item href="guestHistory">
                        <p>Guest Reservation</p>
                      </md-list-item>

                    </md-list>
                  </div>
                  <div class="md-toolbar-section-end">
                    <md-button
                      class="md-just-icon md-simple md-white md-toolbar-toggle"
                    >
                      <span class="icon-bar"></span>
                      <span class="icon-bar"></span>
                      <span class="icon-bar"></span>
                    </md-button>

                    <div class="md-collapse"></div>
                  </div>
                </div>
              </md-toolbar>
            </div>
            <div class="md-layout-item md-size-100">
              <div class="title">
                <h3>Change Meeting Room Rates</h3>
              </div>
            </div>
            <div class="md-layout-item md-size-100">
              <vxe-table class="t_table" :data="sqlData" :edit-rules="validRules" border highlight-hover-row :loading="false"
                  resizable :edit-config="{trigger: 'click', mode: 'cell'}"
                  row-class-name="t_col"
                  @edit-actived="editActivedEvent"
                  @edit-closed="editClosedEvent">
                  <!-- <vxe-table-column title="Id" field="id"></vxe-table-column>
                  <vxe-table-column title="Type" field="type"></vxe-table-column>
                  <vxe-table-column title="TypeName" field="typeName"></vxe-table-column> -->
                  <vxe-table-column title="Name" field="name"></vxe-table-column>
                  <vxe-table-column title="WkDay AM" field="weekday_dayPrice" :formatter="['toFixedString', 2]" :edit-render="{name: 'input', attrs: {type: 'number'}}"></vxe-table-column>
                  <vxe-table-column title="WkDay PM" field="weekday_eveningPrice" :formatter="['toFixedString', 2]" :edit-render="{name: 'input', attrs: {type: 'number'}}"></vxe-table-column>
                  <vxe-table-column title="WkDay Fullday" field="weekday_fullDayPrice" :formatter="['toFixedString', 2]" :edit-render="{name: 'input', attrs: {type: 'number'}}"></vxe-table-column>
                  <vxe-table-column title="Wkend AM" field="weekend_dayPrice" :formatter="['toFixedString', 2]" :edit-render="{name: 'input', attrs: {type: 'number'}}"></vxe-table-column>
                  <vxe-table-column title="Wkend PM" field="weekend_eveningPrice" :formatter="['toFixedString', 2]" :edit-render="{name: 'input', attrs: {type: 'number'}}"></vxe-table-column>
                  <vxe-table-column title="Wkend Fullday" field="weekend_fullDayPrice" :formatter="['toFixedString', 2]" :edit-render="{name: 'input', attrs: {type: 'number'}}"></vxe-table-column>
                  <!-- <vxe-table-column title="Tab" field="tab"></vxe-table-column> -->
                  <vxe-table-column title="Discount" field="discount" :formatter="['toFixedString', 2]" :edit-render="{name: 'input', attrs: {type: 'number'}}"></vxe-table-column>
                  <vxe-table-column title="Total Count" field="totalCount" :edit-render="{name: 'input', attrs: {type: 'number'}}"></vxe-table-column>
                  <vxe-table-column title="Description" field="description" :edit-render="{name: 'input', attrs: {type: 'text'}}"></vxe-table-column>
                </vxe-table>
            </div>
            <div class="md-layout-item md-size-100 text-right">
              <md-button
                href="javascript:void(0)"
                class="md-orange md-lg"
                v-on:click="getter()"
                ><md-icon>send</md-icon> Update Table
              </md-button>
            </div>
          </div>
        </md-card>
      </div>
    </div>
  </div>
</template>

<link rel="stylesheet" href="https://unpkg.com/vxe-table/lib/index.css"/>
<script src="https://unpkg.com/xe-utils"></script>
<script src="https://unpkg.com/vxe-table"></script>
<script>
  import axios from 'axios'
  export default {
    prop: {
    },
    data: () => {
      const roleValid = (rule, value, callback) => {
        if (!isNaN(value)) {
          value = parseInt(value).toFixed(2)
          callback()
        } else {
          callback(new Error('wrong'))
        }
      }
      return {
        sqlData: [],
        flag: false,
        content: '',
        validRules: {
          weekday_dayPrice: [
            { required: true, message: 'The standard formate is 100.00' },
            { validator: roleValid },
            { min: 0, max: 50, message: '3-50' }
          ],
          weekday_eveningPrice: [
            { required: true, message: 'The standard formate is 100.00' },
            { validator: roleValid },
            { min: 0, max: 50, message: '3-50' }
          ],
          weekday_fullDayPrice: [
            { required: true, message: 'The standard formate is 100.00' },
            { validator: roleValid },
            { min: 0, max: 50, message: '3-50' }
          ],
          weekend_dayPrice: [
            { required: true, message: 'The standard formate is 100.00' },
            { validator: roleValid },
            { min: 0, max: 50, message: '3-50' }
          ],
          weekend_eveningPrice: [
            { required: true, message: 'The standard formate is 100.00' },
            { validator: roleValid },
            { min: 0, max: 50, message: '3-50' }
          ],
          weekend_fullDayPrice: [
            { required: true, message: 'The standard formate is 100.00' },
            { validator: roleValid },
            { min: 0, max: 50, message: '3-50' }
          ],
          discount: [
            { required: false, message: 'The standard formate is 100.00' },
            { validator: roleValid },
            { min: 0, max: 50, message: '3-50' }
          ],
          description: [
            { required: false, message: ' ' },
            { min: 0, max: 200, message: 'length 0-200' }
          ]
        }
      }
    },
    directives: {
      numberOnly: {
        bind: function(el) {
          el.handler = function() {
            el.value = Number(el.value.replace(/\D+/, ''))
          }
          el.addEventListener('input', el.handler)
        },
        unbind: function(el) {
          el.removeEventListener('input', el.handler)
        }
      }
    },
    methods: {
      getter: function (e) {
        let that = this
        // console.log(that.sqlData)
        this.content = ''
        if (that.flag) {
          for (let i = 0; i < that.sqlData.length; i++) {
            if (i == 0) {
              this.content += '(' + that.sqlData[i].id + ',' + that.sqlData[i].type + ',"' + that.sqlData[i].typeName + '","' + that.sqlData[i].name + '",' + that.sqlData[i].weekday_dayPrice + ',' + that.sqlData[i].weekday_eveningPrice + ',' + that.sqlData[i].weekday_fullDayPrice + ',' + that.sqlData[i].weekend_dayPrice + ',' + that.sqlData[i].weekend_eveningPrice + ',' + that.sqlData[i].weekend_fullDayPrice + ',"' + that.sqlData[i].tab + '",' + that.sqlData[i].discount + ',' + that.sqlData[i].totalCount + ',"' + that.sqlData[i].description + '")'
            } else {
              this.content += ',(' + that.sqlData[i].id + ',' + that.sqlData[i].type + ',"' + that.sqlData[i].typeName + '","' + that.sqlData[i].name + '",' + that.sqlData[i].weekday_dayPrice + ',' + that.sqlData[i].weekday_eveningPrice + ',' + that.sqlData[i].weekday_fullDayPrice + ',' + that.sqlData[i].weekend_dayPrice + ',' + that.sqlData[i].weekend_eveningPrice + ',' + that.sqlData[i].weekend_fullDayPrice + ',"' + that.sqlData[i].tab + '",' + that.sqlData[i].discount + ',' + that.sqlData[i].totalCount + ',"' + that.sqlData[i].description + '")'
            }
          }
          // console.log(that.content)
          let data = JSON.stringify({"changeFlag": that.flag,"content":that.content});
          // axios.post('/cgi-bin/php/getMeetTable.php', data).then((res) => {
          axios.post('https://www.orangetreetx.com/cgi-bin/php/getMeetTable.php', data).then((res) => {
            // console.log(res.data)
            that.sqlData = res.data.result
            that.flag = false
            that.content = ''
            alert('Success!')
          }).catch((error) => {
            alert('Wrong!')
            console.log(error)
          }).finally((res) => {
  
          })
        }
      },
      cookie: function () {
        let that = this
        if (this.$cookies.isKey("user_session")) {
          let data = JSON.stringify({"name": that.$cookies.get("user_session").name,"password":that.$cookies.get("user_session").password});
          // axios.post('/cgi-bin/php/confirmUser.php', data).then((res) => {
          axios.post('https://www.orangetreetx.com/cgi-bin/php/confirmUser.php', data).then((res) => {
            if(res.status === 200 && res.data.result != false) {
              // that.$cookies.set("user_session", res.data.result[0])
              // console.log(that.$cookies.get("user_session").name, that.$cookies.get("user_session").password)
              console.log('success')
            } else {
              this.$router.push({ path:'/login' })
            }
          }).catch((error) => {
            console.log(error)
          }).finally((res) => {

          })
        } else {
          this.$router.push({ path:'/login' })
        }
      },
      getData: function () {
        let that = this
        let data = JSON.stringify({"changeFlag": that.flag,"content":that.content});
        // axios.post('/cgi-bin/php/getMeetTable.php', data).then((res) => {
        axios.post('https://www.orangetreetx.com/cgi-bin/php/getMeetTable.php', data).then((res) => {
          // console.log(res.data)
          // if(res.status === 200 && res.data.result != false) {
          //   if(that.type == 1) {
          //     this.$router.push({ path:'/manageMeetingRoom' })
          //   } else if(that.type == 2) {
          //     this.$router.push({ path:'/manageGuestRoom' })
          //   }
          // } else {
          //   alert('Can not found username & password!')
          // }
          that.sqlData = res.data.result
        }).catch((error) => {
          console.log(error)
        }).finally((res) => {

        })
      },
      editActivedEvent ({ row, column }, event) {
        // console.log(`打开 ${column.title} 列编辑`)
      },
      editClosedEvent ({ row, column }, event) {
        this.flag = true
        // console.log(`关闭 ${column.title} 列编辑`)
      }
    },
    created() {

    },
    mounted() {
      this.cookie()
      this.getData()
      this.flag = false
      this.content = ''
    },
    destroyed() {
      this.$cookies.remove("user_session")
    },
  }
</script>

<style lang="scss" scoped>
  .page-header {
    height: auto;
  }
  .t_main {
    height: 100%;
    position: relative;
  }
  .md-ripple > span {
    left: auto;
    width: auto;
  }
  .t_content {
    padding-top: 0px;
    .container {
      margin-top: 0px;
      padding: 20px 20px 60px 20px;
    }
  }
  .t_step{
    padding: 100px 0px 10px;
    h2{
      padding-top:20px;
    }
  }
  .t_col {
    color: #333;
    font-weight: bolder;
  }
</style>